import { DuplicateArcgisCivil3dSettingConfigurationsApiRequest } from 'types/requests/arcgis-civil3d-settings/configurations/duplicate-arcgis-civil3d-setting-configurations.request';
import { ArcgisCivil3dSettingConfigurationApiModel } from '../../../types/models/arcgis-civil3d-setting-configuration.model';
import { CreateArcgisCivil3dSettingConfigurationApiRequest } from '../../../types/requests/arcgis-civil3d-settings/configurations/create-arcgis-civil3d-setting-configuration.request';
import { DeleteArcgisCivil3dSettingConfigurationApiRequest } from '../../../types/requests/arcgis-civil3d-settings/configurations/delete-arcgis-civil3d-setting-configuration.request';
import { ExportArcgisCivil3dSettingConfigurationApiRequest } from '../../../types/requests/arcgis-civil3d-settings/configurations/export-arcgis-civil3d-setting-configuration.request';
import { GetArcgisCivil3dSettingConfigurationApiRequest } from '../../../types/requests/arcgis-civil3d-settings/configurations/get-arcgis-civil3d-setting-configuration.request';
import { SearchArcgisCivil3dSettingConfigurationsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/configurations/search-arcgis-civil3d-setting-configurations.request';
import { UpdateArcgisCivil3dSettingConfigurationApiRequest } from '../../../types/requests/arcgis-civil3d-settings/configurations/update-arcgis-civil3d-setting-configuration.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';

export const createSettingConfiguration = (params: CreateArcgisCivil3dSettingConfigurationApiRequest) =>
  client.post<ArcgisCivil3dSettingConfigurationApiModel>('/arcgis-civil3d-settings/configurations', params);

export const updateSettingConfiguration = ({
  settingConfigurationId,
  ...params
}: UpdateArcgisCivil3dSettingConfigurationApiRequest) =>
  client.patch<ArcgisCivil3dSettingConfigurationApiModel>(
    `/arcgis-civil3d-settings/configurations/${settingConfigurationId}`,
    params,
  );

export const getSettingConfiguration = <T extends ArcgisCivil3dSettingConfigurationApiModel>({
  settingConfigurationId,
  ...params
}: GetArcgisCivil3dSettingConfigurationApiRequest) =>
  client.get<T>(`/arcgis-civil3d-settings/configurations/${settingConfigurationId}`, { params });

export const searchSettingConfigurations = <T extends ArcgisCivil3dSettingConfigurationApiModel>(
  params: SearchArcgisCivil3dSettingConfigurationsApiRequest,
) => client.get<CursorPaginatedApiResponse<T>>(`/arcgis-civil3d-settings/configurations`, { params });

export const deleteSettingConfiguration = ({
  settingConfigurationId,
}: DeleteArcgisCivil3dSettingConfigurationApiRequest) =>
  client.delete<void>(`/arcgis-civil3d-settings/configurations/${settingConfigurationId}`);

export const duplicateSettingConfigurations = (params: DuplicateArcgisCivil3dSettingConfigurationsApiRequest) =>
  client.post<ArcgisCivil3dSettingConfigurationApiModel[]>(`/arcgis-civil3d-settings/configurations/duplicate`, params);

export const exportSettingConfiguration = async ({
  settingConfigurationId,
}: ExportArcgisCivil3dSettingConfigurationApiRequest) => {
  const response = await client.get(`/arcgis-civil3d-settings/configurations/${settingConfigurationId}/export`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1].replace(/"/g, ''));
  document.body.appendChild(link);
  link.click();
  link.remove();
  return response;
};
